export const PATH_ABOUT = "/about";
export const PATH_ABOUT_ADMINISTRATION = "/about-administration";
